import { AppRouteProps } from "@bsm/component";
import React from "react";
import { LoginRoutes } from "./views/login/LoginRoutes";
import { ForgotRoutes } from "views/forgot/ForgotRoutes";
const AuthContainer = React.lazy(() => import("./containers/AuthContainer"));
const LogoutContainer = React.lazy(
    () => import("./views/logout/containers/LogoutContainer")
);
export const AuthRoutes: Array<AppRouteProps> = [
    {
        path: "auth",
        title: "Auth.title",
        element: <AuthContainer />,
        children: [
            ...LoginRoutes,
            ...ForgotRoutes
        ],
    },
    {
        path: "logout",
        title: "Auth.Logout",
        element: <LogoutContainer />,
    },
];
